import { OrderedSet, List, fromJS } from 'immutable';
import { SEARCH } from '../../../constants/configTypes';
import { COUNT } from '../../../constants/metricTypes';
import * as DataTypes from '../../../constants/dataTypes';
import { DESC } from '../../../constants/sortOrder';
// @ts-expect-error Untyped import
import { Config } from '../..';
// @ts-expect-error Untyped import
import { Metric } from '../../metrics';
import { defaultProperties } from '../defaultProperties';
// @ts-expect-error Untyped import
import { getBlocklistedForSearch } from '../../../public/blocklisted-for-search';
// @ts-expect-error Untyped import
import { dataTypeToEngagementType } from '../../../retrieve/inboundDb/common/engagement-types';
import { makeFilterGroups, makeFilters } from '../filters';
// @ts-expect-error Untyped import
import { Filter } from '../../filters';
import { buildDrilldownReport } from '../report';
// @ts-expect-error Untyped import
import { isSupportedCrmObject } from '../../../crmObjects/utils';
import { DRILLDOWN_TYPES } from '../../../constants/trackingMetrics';
import { isConfigReport } from '../../../tsTypes/reportTypes';
import { areFilterGroupsSupported } from '../../../utils/areFilterGroupsSupported';
import { applyFiltersToFilterGroups } from '../../../report/configReportSetters';
import { getObjectTypeId, getReportConfig } from '../../../report/configReportGetters';
import { getHiddenProperties } from '../../../properties/propertyUtils';
const identity = x => x;
const DEAL_PROGRESS = 'BUCKET_dealProgress';
const INBOUNDDB_DATATYPES = [...dataTypeToEngagementType.keySeq().toArray(), DataTypes.CONTACTS, DataTypes.COMPANIES, DataTypes.DEALS, DataTypes.ENGAGEMENT, DataTypes.TICKETS, DataTypes.PRODUCTS, DataTypes.LINE_ITEMS, DataTypes.SOCIAL_POSTS, DataTypes.FEEDBACK_SUBMISSIONS, DataTypes.CRM_OBJECT, DataTypes.GOAL_TARGET, 'mockDataTypeForTesting'];
const getDrilldownDataType = dataType => dataTypeToEngagementType.has(dataType) ? DataTypes.ENGAGEMENT : dataType;
const getEngagementFilter = engagementType => {
  return Filter({
    property: 'hs_engagement_type',
    operator: 'IN',
    values: [engagementType]
  });
};
const addEngagementTypeFilter = (config, filterGroupsSupported = false) => {
  if (!dataTypeToEngagementType.has(config.get('dataType'))) {
    return identity;
  }
  const engagementType = dataTypeToEngagementType.get(config.get('dataType'));
  return filters => {
    const engagementFilter = getEngagementFilter(engagementType);
    const filterGroups = filters.get('filterGroups');
    if (filterGroupsSupported && filterGroups.size > 0) {
      const updatedFilterGroups = applyFiltersToFilterGroups(filterGroups, List([engagementFilter]));
      return filters.set('filterGroups', updatedFilterGroups);
    }
    return filters.update('custom', List(), customFilters => customFilters.push(engagementFilter));
  };
};
const getInboundDbDrilldown = (report, keys, options, _dataTypeModule, userInfo) => {
  const config = report.get('config');
  const dimensions = config.get('dimensions') || List();
  const metrics = config.get('metrics') || List();
  const dataType = report.getIn(['config', 'dataType']);
  const adjustedDatatype = isSupportedCrmObject(dataType) ? report.getIn(['config', 'objectTypeId']) : getDrilldownDataType(dataType);
  const dateRangeProperty = config.getIn(['filters', 'dateRange', 'property']);
  const filterProperties = dateRangeProperty != null ? [dateRangeProperty] : [];
  const metric = keys.get(report.getIn(['config', 'dimensions'], List()).count());
  const metricProperties = metrics.map(m => m.get('property')).filter(property => property !== 'count');
  const dataTypeDefaults = defaultProperties.hasOwnProperty(dataType) ? defaultProperties[dataType] || [] : [];
  const dataColumnProperties = report.getIn(['displayParams', 'dataColumns']) || [];
  const properties = OrderedSet([...dataTypeDefaults, ...dimensions.toJS(), ...filterProperties, ...metricProperties.toJS(), ...dataColumnProperties]).toList().filter(property => property !== DEAL_PROGRESS && !property.includes('QUOTA'));
  return Promise.all([getBlocklistedForSearch(adjustedDatatype), getHiddenProperties(adjustedDatatype)]).then(([blocklist, hiddenProperties]) => {
    const filteredProperties = properties.filter(property => !blocklist.includes(property) && !hiddenProperties.includes(property));
    const filterGroupsSupported = areFilterGroupsSupported(report, userInfo);
    const makeFilterPromise = filterGroupsSupported ? makeFilterGroups(config, keys, options) : makeFilters(config, keys, options);
    return makeFilterPromise.then(updatedFilters => addEngagementTypeFilter(getReportConfig(report), filterGroupsSupported)(updatedFilters)).then(updatedFilters => {
      return Config({
        configType: SEARCH,
        limit: 5,
        dataType,
        objectTypeId: getObjectTypeId(report),
        metrics: filteredProperties.map(property => Metric({
          property,
          metricTypes: [COUNT]
        })),
        filters: updatedFilters,
        sort: fromJS([{
          property: metric,
          order: DESC
        }])
      });
    }).then(drilledConfig => buildDrilldownReport(report, drilledConfig, options));
  });
};
const inboundDbGenerator = {
  isSupported: report => isConfigReport(report) && INBOUNDDB_DATATYPES.includes(report.getIn(['config', 'dataType'])),
  generate: getInboundDbDrilldown,
  trackingName: DRILLDOWN_TYPES.CRM_OBJECT
};
export default inboundDbGenerator;